import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  empresas_externas: [],
  totalCount: 0,
}

export const Slice = createSlice({
  name: 'empresas_externas',
  initialState,
  reducers: {
    setEmpresasExternas: (state, action) => {
      state.empresas_externas = action.payload
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload
    },
  },
})

export const { setEmpresasExternas, setTotalCount } = Slice.actions
export default Slice.reducer
